// Generated code for Big.Entities.ZaakType.
// Edit _Enum.tst to change the generated output.

export enum ZaakType {
    onbekend = 0,
    artikel3 = 1,
    artikel34 = 2,
    vvAssessment = 5,
    bezwaar = 6,
    beroep = 7,
    hogerBeroep = 8,
    supervisieGelijkwaardig = 10,
    supervisieNagenoegGelijkwaardig = 11,
    doorhalingArtikelRegistratie = 12,
    specialisme = 13,
    schriftelijkVerzoek = 14,
    rechterlijkeUitspraak = 15,
    erkenningDiploma = 16,
    doorhalingArtikel34Registratie = 17,
    toetsenDiplomasUzi = 18,
    schriftelijkVerzoekSkp = 19,
    verklaring = 20,
    intrekkingMaatregelOfBevel = 21,
    registratieVermelding = 22,
    herregistratieBig = 23,
    aanschrijvingHerregistratieBigSpecialist = 24,
    aanschrijvingHerregistratieBig = 25,
    herregistratieBigNaDoorhaling = 26,
    aanvragenBigLogin = 27,
    aanvragenNieuwWachtwoord = 28,
    artikel36a = 29
}
(ZaakType as any).name = 'ZaakType';
